module.exports = __webpack_public_path__ + "img/attila-la-roche.aad4ea75.png";